import { IBackStory } from "@src/components/Backstory";
import image from "../../../../public/images/t3-demo-1.jpg";
import bgImg from "../../../../public/images/t19bg.png";
import React from "react";
import Image from "next/image";
import { truncate } from "lodash";
import { shimmer, toBase64 } from "@src/utils/shimmer";
import DialogModal from "@src/components/Dialog";
import BackstoryModal from "@src/components/modals/BackstoryModal";
import { motion } from "framer-motion";
import defaultImage from "../../../../public/images/image20.jpeg";

const Backstory: React.FC<IBackStory> = ({
  eventId,
  backStoryData,
  sectionImage,
}) => {
  const firstStory = backStoryData?.getBackStory?.[0];

  return firstStory ? (
    <div className="w-full h-[120vh] sm:h-[100vh] relative overflow-hidden flex flex-col lg:flex-row">
      {/* Text Section - First on mobile, second on desktop */}
      <div className="flex-1 h-1/2 lg:h-full relative order-1 lg:order-2">
        {/* Background image */}
        <div className="absolute inset-0">
          <Image
            src={bgImg}
            alt="background"
            layout="fill"
            className="object-cover object-center"
            onError={(e) => console.log("Background image failed to load:", e)}
            onLoad={() => console.log("Background image loaded successfully")}
          />
        </div>

        <div className="relative z-10 h-full flex flex-col justify-center items-center px-4 lg:px-20">
          {/* Story Content */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{
              opacity: 1,
              y: 0,
              transition: {
                delay: 0.4,
                duration: 0.8,
                ease: [0.79, 0.14, 0.15, 0.86],
              },
            }}
            className="flex-1 flex flex-col justify-center max-w-2xl"
          >
            <h2 className="font-ntFab text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-light text-[#FCE2B0] text-center mb-4">
              {firstStory?.title || "Our Story"}
            </h2>
            <p className="text-[#FCE2B0] text-base sm:text-lg md:text-xl lg:text-2xl font-normal font-ebGaramond leading-relaxed text-center">
              {truncate(firstStory?.story, {
                length: 800,
              }) || "Our love story begins here..."}
            </p>
            <p className="mt-4 text-center font-ebGaramond text-[#FCE2B0]">
              {firstStory?.role}
            </p>

            {/* <div className="flex justify-center">
              <DialogModal
                trigger={
                  <motion.button
                    initial={{ opacity: 0, y: 20 }}
                    animate={{
                      opacity: 1,
                      y: 0,
                      transition: {
                        delay: 0.6,
                        duration: 0.6,
                      },
                    }}
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    className="border border-[#FCE2B0] text-[#FCE2B0] px-8 py-3 text-sm md:text-base tracking-wider font-ebGaramond hover:bg-[#FCE2B0] hover:text-[#00234B] transition-all duration-300 rounded-2xl"
                  >
                    CONTINUE READING
                  </motion.button>
                }
              >
                <BackstoryModal
                  title={firstStory?.title ?? ""}
                  story={firstStory?.story ?? ""}
                  role={firstStory?.role ?? ""}
                />
              </DialogModal>
            </div> */}
          </motion.div>
        </div>
      </div>

      {/* Image Section - Second on mobile, first on desktop */}
      <div className="flex-1 h-1/2 lg:h-full order-2 lg:order-1 lg:hidden">
        <motion.div
          initial={{ scale: 1.1, opacity: 0 }}
          animate={{
            scale: 1.0,
            opacity: 1,
            transition: {
              delay: 0.3,
              duration: 0.8,
              ease: [0.79, 0.14, 0.15, 0.86],
            },
          }}
          className="relative w-full h-full"
        >
          <Image
            placeholder="blur"
            loading="eager"
            layout="fill"
            blurDataURL={`data:image/svg+xml;base64,${toBase64(
              shimmer(700, 475)
            )}`}
            src={sectionImage || defaultImage}
            alt={firstStory?.title || "Wedding photo"}
            className="object-cover object-center"
            sizes="(max-width: 1024px) 100vw, 50vw"
          />

          {/* Optional overlay for better text readability on mobile */}
          <div className="absolute inset-0 bg-black bg-opacity-10 lg:bg-opacity-0"></div>
        </motion.div>
      </div>
    </div>
  ) : (
    <></>
  );
};

export default Backstory;
